import { defineComponent, getCurrentInstance } from "vue";
import { useMessage } from "naive-ui";
export default defineComponent({
  setup: function setup() {
    window.$message = useMessage();
  }
});